// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2x_yc","addWidgetButton":"Header_addWidgetButton__qWcwj","dashboardTabs":"Header_dashboardTabs__2UVnd","active":"Header_active__2EGgl"};